import { useEffect } from "react";
import { useDispatch } from "react-redux";
import * as authActions from "../actions/auth";
import { useNavigate } from "react-router-dom";

const Callback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(authActions.authReceived(window.location.href));
    setTimeout(() => navigate("/"), 1000);
  }, [dispatch, navigate]);
  return null;
};

export default Callback;
